import React from 'react';
import styled from 'styled-components';

const Box = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  height: 16px;
  width: 16px;
  flex-shrink: 0;

  cursor: pointer;
  border: 1px solid
    ${({ theme, $isChecked }) => ($isChecked ? theme.themeColors.primaryCtaButton : theme.themeColors.border)};
  border-radius: 3px;
  background: ${({ theme, $isChecked }) => ($isChecked ? theme.themeColors.primaryCtaButton : 'transparent')};
  color: ${({ theme }) => theme.themeColors.buttonText};
  font-size: 11px;
  line-height: 1;
`;

export const SelectionCheckbox = ({ isChecked, isIndeterminate, onChange, ariaLabel }) => {
  const handleClick = (event) => {
    // Rows are clickable; selecting one must not also open it.
    event.stopPropagation();
    onChange(!isChecked);
  };

  return (
    <Box
      role="checkbox"
      aria-checked={isIndeterminate ? 'mixed' : isChecked}
      aria-label={ariaLabel}
      tabIndex={0}
      $isChecked={isChecked || isIndeterminate}
      onClick={handleClick}
      onKeyDown={(event) => {
        if (event.key === ' ' || event.key === 'Enter') {
          event.preventDefault();
          handleClick(event);
        }
      }}
    >
      {isIndeterminate ? '–' : isChecked ? '✓' : ''}
    </Box>
  );
};
